module.exports = __webpack_public_path__ + "static/Seonadh-2e9a24e17cdda648ddaa83415ac39aad.jpg";